import React from 'react';
import PeriodGrid from "./components/PeriodGrid";
import {bindActionCreators} from "redux";
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import * as actions from './period.actions';
import * as selectors from './period.selectors'
import * as applicationActions from '../../application.actions';
import * as applicationSelectors from '../../application.selectors';

class PeriodContainer extends React.PureComponent {

  state = {
    show: false
  };

  componentDidMount() {

    setTimeout(() => this.setState({show: true}), 1500);

    const {roles, userFacility, actions: {setPageTitle, fetchPeriods, setBreadcrumbs}} = this.props;

    fetchPeriods(roles.nursingFacility ? userFacility.id : null);
    setPageTitle('PASRR Review');
    setBreadcrumbs([
      {active: true, title: 'Periods'},
    ]);
  }

  componentWillReceiveProps(nextProps) {
    const {roles, userFacility, actions: {fetchPeriods}} = nextProps;
    if (this.props.userFacility !== nextProps.userFacility) {
      fetchPeriods(roles.nursingFacility ? userFacility.id : null);
    }
  }

  render() {
    const {roles, periods} = this.props;
    return (
      <PeriodGrid
        show={this.state.show}
        data={periods}
        roles={roles}
      />
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      roles: applicationSelectors.roles(state),
      fetching: state.periods.fetching,
      periods: selectors.periods(state),
      userFacility: applicationSelectors.userFacility(state)
    }),
    (dispatch) => ({actions: bindActionCreators({...applicationActions, ...actions}, dispatch)})
  )(PeriodContainer)
);


// WEBPACK FOOTER //
// ./src/modules/periods/PeriodContainer.js